import React from 'react';
import { FaLaptopCode, FaLightbulb, FaTools } from "react-icons/fa";
import { GiShinyApple } from "react-icons/gi";
import { BsArrowRight } from "react-icons/bs";
import Bounce from 'react-reveal/Bounce';
import Fade from 'react-reveal/Fade';
import Typewriter from 'typewriter-effect';

const Description = () => {
    return (
        <div className="mb-10">
            <Bounce left>
                <p className="text-sm font-bold">
                    Hello! <span>My name is ...</span>
                </p>
            </Bounce>

            {/* name heading  */}

            <Fade top>
                <h1 className="text-3xl md:text-5xl font-semibold ">
                    Moniruzzaman
                    <span className="flex">
                        Sujon
                        <div className="0 ">
                            <Typewriter
                                options={{
                                    strings: [""],
                                    autoStart: true,
                                    loop: true,
                                }}
                            />
                        </div>
                    </span>
                </h1>
            </Fade>

            {/* name description  */}

            <Fade bottom>
                <p className="mt-5 text-md font-semibold md:tracking-wide text-justify ">
                    A passionate{" "}
                    <span className="bg-teal-900 px-1">💻 Full Stack Developer</span>{" "}
                    with excellent{" "}
                    <span className="bg-teal-900 px-1">💡 problem-solving</span> skills
                    and the ability to convert them into elegant digital experiences.
                    I thrive on challenges and constantly seek to expand my skillset.
                    <br />
                    <br />
                    I have experience in developing both frontend and backend applications using{" "}
                    <span className="bg-teal-900 px-1">🔧 JavaScript</span> and
                    specifically have strong expertise with{" "}
                    <span className="bg-teal-900 px-1">⚛️ React JS</span> and{" "}
                    <span className="bg-teal-900 px-1">⚙️ Node JS</span>.
                    <br />
                    <br />
                    Apart from coding, I enjoy exploring new technologies, reading tech blogs, and staying up-to-date with the latest industry trends.
                    <br />
                    <br />
                    <span className="font-bold">Let's create something amazing together! <BsArrowRight className="inline-block align-middle" /></span>
                </p>
            </Fade>
        </div>
    );
};

export default Description;
